import paulPic from "@/public/images/artists/paul.png";
import { Artist } from "@/types/types";

export const paul = {
  id: "168",
  name: "Paul",
  image: paulPic,
  description: `Paul's tone is smooth and full-bodied, marked by a deep baritone and a precise, controlled vibrato that adds warmth to his delivery.  His style mixes a slightly formal, refined enunciation with the unmistakable energy of 80s pop, giving his voice a charismatic charm.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fpaul-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Male",
    tags: {
      primary: ["Pop", "Dance", "Disco", "Belting"],
      secondary: ["80s"],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "High",
      },
      specific: {
        low: 46,
        high: 72,
      },
      sweetSpot: 63,
    },
  },
} as const satisfies Artist;
